import React from 'react';

function CommerceNotation() {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-[1200px] mx-auto p-8 bg-white rounded-lg shadow-lg">
        <h1 className="text-center mb-8 text-4xl font-extrabold text-gray-900">
          特定商取引法に基づく表記
        </h1>
        <div className="overflow-x-auto">
          <table className="min-w-full border-collapse border border-gray-300 mb-8">
            <tbody>
              <tr>
                <th className="bg-gray-100 border border-gray-300 p-2 w-1/3 text-left align-top">
                  販売事業者の名称
                </th>
                <td className="border border-gray-300 p-2 align-top">
                  土屋奏太（個人事業主）
                </td>
              </tr>
              <tr>
                <th className="bg-gray-100 border border-gray-300 p-2 text-left align-top">
                  運営統括責任者
                </th>
                <td className="border border-gray-300 p-2 align-top">
                  土屋奏太
                </td>
              </tr>
              <tr>
                <th className="bg-gray-100 border border-gray-300 p-2 text-left align-top">
                  所在地
                </th>
                <td className="border border-gray-300 p-2 align-top">
                  〒036-8223 青森県弘前市大字富士見町13-5 アヴァンセ2 106
                </td>
              </tr>
              <tr>
                <th className="bg-gray-100 border border-gray-300 p-2 text-left align-top">
                  電話番号
                </th>
                <td className="border border-gray-300 p-2 align-top">
                  090-7860-1615
                </td>
              </tr>
              <tr>
                <th className="bg-gray-100 border border-gray-300 p-2 text-left align-top">
                  受付時間
                </th>
                <td className="border border-gray-300 p-2 align-top">
                  10:00-18:00（土日祝を除く）
                </td>
              </tr>
              <tr>
                <th className="bg-gray-100 border border-gray-300 p-2 text-left align-top">
                  メールアドレス
                </th>
                <td className="border border-gray-300 p-2 align-top">
                  20m.ka.tsuchiya@gmail.com
                </td>
              </tr>
              <tr>
                <th className="bg-gray-100 border border-gray-300 p-2 text-left align-top">
                  追加手数料
                </th>
                <td className="border border-gray-300 p-2 align-top">
                  商品/サービスの特性上、追加料金（送料等）は発生いたしません。
                </td>
              </tr>
              <tr>
                <th className="bg-gray-100 border border-gray-300 p-2 text-left align-top">
                  キャンセル・返品
                </th>
                <td className="border border-gray-300 p-2 align-top">
                  <p>
                    本サービスはデジタルコンテンツ・オンラインサービスであるため、クーリングオフの適用対象外となります。決済完了後のキャンセル・返金は原則としてお受けできません。
                  </p>
                  <p className="mt-2">
                    ただし、当社の責に帰す重大な不備や障害により正常にサービスを利用できない場合は、速やかにご連絡ください。調査のうえ、返金が適切であると判断した場合には、相応の対応をいたします。
                  </p>
                  <p className="mt-2">
                    返金手続きについては当社宛にメール等でお問い合わせのうえ、ご案内する方法に従ってください。
                  </p>
                </td>
              </tr>
              <tr>
                <th className="bg-gray-100 border border-gray-300 p-2 text-left align-top">
                  商品の引渡し時期
                </th>
                <td className="border border-gray-300 p-2 align-top">
                  決済完了後、即時利用可能
                </td>
              </tr>
              <tr>
                <th className="bg-gray-100 border border-gray-300 p-2 text-left align-top">
                  受け付け可能な決済手段
                </th>
                <td className="border border-gray-300 p-2 align-top">
                  クレジットカード決済（Stripe）
                </td>
              </tr>
              <tr>
                <th className="bg-gray-100 border border-gray-300 p-2 text-left align-top">
                  決済期間
                </th>
                <td className="border border-gray-300 p-2 align-top">
                  クレジットカード決済の場合、決済完了時に即時処理されます
                </td>
              </tr>
              <tr>
                <th className="bg-gray-100 border border-gray-300 p-2 text-left align-top">
                  販売価格
                </th>
                <td className="border border-gray-300 p-2 align-top">
                  500円／人（税込）
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="mb-8 text-sm text-gray-500">
          ※本サービスの利用契約は、決済が完了した時点で成立します。<br />
          ※上記内容やサービス提供条件は、必要に応じて改定される場合があります。
        </p>
      </div>
    </div>
  );
}

export default CommerceNotation;
